import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDocument = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 100,
	height: 110,
	viewBox: "0 0 100 110",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M0 15C0 6.71575 6.71573 0 15 0H72.3692L85.4359 14.2308L97.4974 26.7538V91.4462C97.4974 99.7304 90.7817 106.446 82.4974 106.446H15C6.71571 106.446 0 99.7304 0 91.4462V15Z",
			fill: "#FFCE00"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .3,
			d: "M0.864079 14.8576C0.942194 6.62928 7.63469 0 15.8634 0H73.3744V18.3231C73.3744 23.2936 77.4038 27.3231 82.3744 27.3231H98V90.8769C98 99.1612 91.2843 105.877 83 105.877H15.1431C6.80314 105.877 0.0645818 99.0741 0.143752 90.7345L0.864079 14.8576Z",
			fill: "#FFCE00"
		}),
		/* @__PURE__ */ _jsx("g", {
			transform: "translate(20,20)",
			clipPath: "url(#clip0_1434_7825)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M4.14605 58.1775C3.24371 58.1775 2.40185 57.8361 1.71227 57.1899C0.402233 55.9624 -0.187447 54.3616 0.0523133 52.6821C0.235913 51.3897 0.787793 47.5022 12.7655 41.9653C16.896 34.2763 20.8051 24.7774 22.9429 17.2502C19.6678 11.5365 18.6564 7.43325 19.8509 4.7252C20.3617 3.56804 21.4984 2.14639 24.0083 1.94802C24.1325 1.9384 24.2535 1.93359 24.3718 1.93359C25.7212 1.93359 26.8898 2.56898 27.6614 3.72253C28.6216 5.15801 29.6195 8.03918 27.4838 16.4958C31.0953 22.3074 36.5655 28.9534 41.5146 33.5394C43.0671 33.362 44.4851 33.2725 45.7412 33.2725C49.6265 33.2725 52.0019 34.0984 53.2169 35.8711C53.9724 36.9748 54.1906 38.3874 53.8309 39.8475C53.272 42.1114 51.7006 43.4627 49.6249 43.4627C47.3147 43.4627 44.1682 41.7471 40.2661 38.3616C32.9162 39.4424 23.2199 42.3163 15.6027 45.6778C8.66045 58.1769 5.27195 58.1775 4.14605 58.1775ZM4.15955 53.3812C4.17467 53.4076 4.20599 53.4569 4.26647 53.5254C4.79621 53.3613 6.07115 52.3989 8.07509 49.6398C5.14181 51.5664 4.22651 52.9045 4.15955 53.3812ZM25.9032 21.9335C24.1028 27.4915 21.5854 33.7137 18.827 39.434C24.4641 37.2994 30.6606 35.4948 36.1119 34.4056C32.5036 30.6864 28.8419 26.2141 25.9032 21.9335ZM47.237 37.957C48.3316 38.575 49.1318 38.8358 49.6249 38.8358C49.6837 38.8352 49.7275 38.8316 49.7566 38.8268C49.7734 38.7878 49.7977 38.7228 49.8225 38.623C49.8236 38.6188 49.8241 38.6146 49.8252 38.6104C49.6011 38.4547 48.9158 38.0965 47.237 37.957ZM24.3626 6.56103C24.3431 6.56103 24.3237 6.56223 24.3026 6.56403C23.7459 6.60791 23.5866 6.75699 23.5844 6.7582C23.4484 6.97821 23.3836 8.14198 24.4052 10.6595C24.7805 7.88169 24.4744 6.83213 24.3626 6.56103Z",
				fill: "#634F00"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1434_7825",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 54,
				height: 75.1402,
				fill: "white"
			})
		}) })
	]
});
export default SvgDocument;
